import { useStateValue } from "frontend/state";
import * as Sentry from "@sentry/nextjs";
import { addTestUtils, TEST_ACCOUNTS } from "frontend/utils/test-utils";
import { initMixPanelUser } from "utils/analytic-utils";
import { useEffect } from "react";
import brazeSdk from "frontend/braze-sdk";
import { initBigBrainUser } from "frontend/services/bigBrainService";
import { useAtomValue } from "jotai";
import { userPlanFeaturesAtom } from "state-atoms/plan-features-atoms";
import { isCIM } from "utils/url-utils";

declare global {
  interface Window {
    PLAN_FEATURES: Map<string, unknown>;
  }
}

export default function InitUserUtils() {
  const [{ user }] = useStateValue();
  const planFeatures = useAtomValue(userPlanFeaturesAtom);

  useEffect(() => {
    if (user) {
      Sentry.setUser({ id: user.id, accountId: user.account?.id, email: user.email });
      addTestUtils(user.account.id);
      brazeSdk.initBrazeUser(user.id.toString(), user);
      initMixPanelUser(user);
      if (isCIM()) {
        initBigBrainUser(user.id, user.account?.id);
      }
    }
  }, [user]);

  useEffect(() => {
    if (planFeatures && TEST_ACCOUNTS.has(user?.account?.id)) {
      window.PLAN_FEATURES = planFeatures;
    }
  }, [planFeatures, user]);

  return null;
}
